console.log(process);
console.log(process.env);
console.log(process.env.VUE_APP_API_BASE_URL);
console.log(process.env.VUE_APP_TITLE);
console.log(process.env.VUE_APP_SECRET);
let apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const nodeEnv = process.env.NODE_ENV;

if (!apiBaseUrl) {
  switch (nodeEnv) {
    case 'development':
      //   apiBaseUrl = 'http://localhost:1040';
      apiBaseUrl = 'http://api.jseia.cn'
      break;
    default:
      apiBaseUrl = 'http://api.jseia.cn';
      break;
  }
}

export {
  apiBaseUrl
};
